import React from 'react';
import { useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { Warning } from '@wix/da-ds/pkg/Icons/Confirmations/Warning';
import { CancelButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import BuyCoreBrandedButton from '@wix/da-shared-react/pkg/Button/core/dsPresets/BuyCoreBrandedButton';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { BiData, BuyCoreButtonBiEvent } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';

import s from './GroupOrChannelFullModal.scss';

const LOCALE_KEY = 'damz.modal.groupOrChannelFullModal';

export interface Props {
  roomType: 'multi' | 'community';
  isUpsell?: boolean;
  requestClose: () => void;
}

const GroupOrChannelFullModal: React.FC<Props> = ({
  roomType,
  isUpsell,
  requestClose,
}) => {
  const { t } = useTranslation('damz');
  const localeBase = `${LOCALE_KEY}.${roomType}${isUpsell ? '.upsell' : ''}`;

  return (
    <MessageModal
      className={s['root']}
      isOpen
      variant="horizontal"
      image={<Warning />}
      onRequestClose={requestClose}
      title={t(`${localeBase}.title`)}
      message={t(`${localeBase}.message`)}
      footerButtons={[
        <CancelButton key="cancel" onClick={requestClose}>
          {t(`${localeBase}.cancel`)}
        </CancelButton>,

        isUpsell ? (
          <BuyCoreBrandedButton
            key="confirm"
            size="large"
            withMobileDefaultLabel={false}
            rel="noopener"
            referer={
              typeof window !== 'undefined' ? window.location.href : undefined
            }
            biData={BiData<BuyCoreButtonBiEvent>({
              evid: 375,
              referral_info: ReferralType.MESSAGES_ADD_TO_CHANNEL,
            })}
          >
            {t(`${localeBase}.confirm`)}
          </BuyCoreBrandedButton>
        ) : (
          <BrandedButton
            key="confirm"
            size="large"
            variant="brand-green"
            onClick={requestClose}
          >
            {t(`${localeBase}.confirm`)}
          </BrandedButton>
        ),
      ]}
    />
  );
};

export default GroupOrChannelFullModal;
